angular.module('buildingSpecialistsModule').component('buildingSpecialistsBlock', {
    templateUrl: 'buildingSpecialistsBlock/buildingSpecialistsBlock.html',
    bindings: {
        rpc: '@',
        leadkitUrl: '@',
        buildingName: '@',
        specialistsLink: '@',
        isAgent: '@',
        isLkAgent: '@',
    },
    controller: ['$sce', '$element', '$timeout', 'crResourcesService', function ($sce, $element, $timeout, crResourcesService) {
        var self = this;
        self.isLoaded = false;
        self.buildingSpecialists = [];


        // Function to determine initial fallback image
        self.getSpecialistImage = function (specialist) {
            return specialist.photo_url || specialist.photo_url_alt || specialist.photo_url_ds || '';
        };

        // Fallback function to handle broken images dynamically
        self.handleImageError = function (imgElement) {
            var scope = angular.element(imgElement).scope();
            var specialist = scope.specialist; // Retrieve specialist from scope

            if (!specialist) {
                console.warn("Specialist is undefined");
                return;
            }

            var currentSrc = imgElement.src;

            if (currentSrc === specialist.photo_url && specialist.photo_url_alt) {
                imgElement.src = specialist.photo_url_alt;
            } else if (currentSrc === specialist.photo_url_alt && specialist.photo_url_ds) {
                imgElement.src = specialist.photo_url_ds;
            } else {
                imgElement.style.display = 'none'; // Hide if all fail
            }
        };


        self.loadListingHistory = function () {
            crResourcesService.get(self.rpc).$promise.then((val) => {
                if (val.items && val.items.length > 0) {
                    self.buildingSpecialists = val.items.map(specialist => {
                        specialist.finalPhotoUrl = self.getSpecialistImage(specialist);
                        return specialist;
                    });
                } else {
                    document.querySelector('.building-specialists-block').remove();
                }
                self.isLoaded = true;
            });
        };
        self.loadListingHistory();
    }],
});
